import { Injectable } from '@angular/core';
import { Action, Actions, InitState, ofActionSuccessful, State, StateContext, Store } from '@ngxs/store';
import { DashboardState } from '../dashboard/dashboard.state';
import { NotificationNativeState } from '../notification/notification-native/notification-native.state';
import { NotificationToastrState } from '../notification/notification-toastr/notification-toastr.state';
import { SamwinState } from '../samwin/samwin.state';
import { ServerCommunicationState } from '../server-communication/server-communication.state';
import { SessionState } from '../session/session.state';
import { SettingsState } from '../settings/settings.state';
import { ChangeAppVisibility } from './app.actions';
import { AuthenticationSettingsState } from '../authentication-settings/authentication-settings.state';

export interface AppStateModel {
   isVisible: boolean;
}

@State<AppStateModel>({
   name: 'samwebState',
   defaults: {
      isVisible: false,
   },
   children: [
      AuthenticationSettingsState,
      SettingsState,
      SessionState,
      ServerCommunicationState,
      SamwinState,
      NotificationToastrState,
      NotificationNativeState,
      DashboardState,
   ],
})
@Injectable()
export class AppState {
   public constructor(private readonly store: Store, private actions$: Actions) {
      document.addEventListener('visibilitychange', () => this.triggerChangeAppVisibility());
      actions$.pipe(ofActionSuccessful(InitState)).subscribe(() => this.triggerChangeAppVisibility());
   }

   @Action(ChangeAppVisibility)
   public changeIsVisible(ctx: StateContext<AppStateModel>, action: ChangeAppVisibility) {
      ctx.patchState({
         isVisible: action.isVisible,
      });
   }

   private triggerChangeAppVisibility(): void {
      this.store.dispatch(new ChangeAppVisibility(document.visibilityState === 'visible'));
   }
}
